export default {
      id: "chart-usage",
      viewBox: "0 0 30 23",
      url: __webpack_public_path__ + "img/icons.svg#chart",
      toString: function () {
        return this.url;
      }
    }